// React
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

// Prop types
import PropTypes from 'prop-types';

// Mui styles
import { withStyles, MuiThemeProvider, createTheme } from '@material-ui/core/styles';

// Mui core
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

// Icon
import SearchIcon from '@material-ui/icons/Search';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';

import { MEMO_CONFIRM, MEMO_TODO_OPEN, MEMO_TODO_CLOSE } from '../../../const';

import { withRoomContext } from '../../../RoomContext';

const styles = () =>
	({
		root : {
			width         : '100%',
			height        : '100%',
			display       : 'flex',
			flexDirection : 'column'
		},
		tableTitle : {
			color          : '#878686',
			fontSize       : '1rem',
			display        : 'flex',
			alignItems     : 'center',
			justifyContent : 'center',
			height         : '3rem'
		},
		tableIcon : {
			width       : '2rem',
			height      : '2rem',
			marginRight : '0.5rem'
		},
		tableBg : {
			display       : 'flex',
			position      : 'absolute',
			height        : '100%',
			width         : '100%',
			zIndex        : '0',
			pointerEvents : 'none',
			paddingRight  : 'calc(4% + 1rem + 1px)',
			paddingBottom : '4%'
		},
		table : {
			backgroundColor : 'white',
			borderRadius    : '5px',
			boxShadow       : '3px 3px 10px #aaa',
			padding         : '2%',
			height          : 'calc(94% - 3rem)',
			position        : 'relative'
		},
		tableHeader : {
			display : 'flex'
		},
		tableHeaderText : {
			fontSize      : '0.8rem',
			textAlign     : 'center',
			paddingBottom : '2rem',
			color         : '#999898'
		},
		columnNo : {
			width : '5%'
		},
		columnNoData : {
			border       : 'none',
			borderRadius : '0.3rem',
			background   : '#999898',
			padding      : '1.2rem 0',
			color        : 'white',
			textAlign    : 'center',
			margin       : '0 0.3rem'
		},
		columnDate : {
			width : '18%'
		},
		columnName : {
			width : '18%'
		},
		columnAddress : {
			width : '18%'
		},
		columnNumber : {
			width : '10%'
		},
		columnTitle : {
			width : '35%'
		},
		columnAction : {
			width : '14%'
		},
		tableData : {
			display      : 'flex',
			listStyle    : 'none',
			marginBottom : '0.8rem',
			position     : 'relative'
		},
		tableDataValues : {
			display        : 'flex',
			alignItems     : 'center',
			zIndex         : 1,
			height         : '100%',
			justifyContent : 'flex-end'
		},
		tableDataValue : {
			color        : '#999898',
			textAlign    : 'left',
			fontSize     : '0.8rem',
			whiteSpace   : 'nowrap',
			textOverflow : 'ellipsis',
			overflow     : 'hidden',
			padding      : '0'
		},
		rowContentBg : {
			height     : '100%',
			background : 'rgba(0,0,0,0.1)'
		},
		rowBorderStart : {
			borderRadius : '0.5rem 0 0 0.5rem'
		},
		rowBorderEnd : {
			borderRadius : '0 0.5rem 0.5rem 0'
		},
		tableBgLine : {
			height      : '100%',
			borderRight : '1px solid #ccc'
		},
		itemCenter : {
			width          : '100%',
			height         : '100%',
			justifyContent : 'center',
			display        : 'flex',
			alignItems     : 'center'
		},
		itemLeft : {
			width          : '100%',
			height         : '100%',
			justifyContent : 'flex-start',
			display        : 'flex',
			alignItems     : 'center',
			paddingLeft    : '5%',
			textOverflow   : 'ellipsis',
			overflow       : 'hidden'
		},
		actionBtn : {
			background   : 'white',
			border       : '1px solid #999898',
			borderRadius : '0.3rem',
			color        : '#999898',
			width        : '4rem',
			padding      : '0.1rem',
			fontSize     : '0.8rem',
			'&:hover'    :
			{
				backgroundColor : '#c0d748',
				color           : 'white',
				opacity         : 0.8
			}
		},
		actionDate : {
			background   : '#e97f00',
			border       : '1px solid #e97f00',
			borderRadius : '0.2rem',
			color        : 'white',
			width        : '4rem',
			padding      : '0.1rem',
			fontSize     : '0.5rem',
			height       : '1rem',
			'&:hover'    :
			{
				backgroundColor : '#e97f00'
			}
		},
		scrollBar : {
			overflow               : 'auto',
			height                 : '100%',
			paddingRight           : '1rem',
			'&::-webkit-scrollbar' : {
				background   : '#ccc',
				width        : '7px',
				height       : '7px',
				borderRadius : '100px'
			},
			'&::-webkit-scrollbar-thumb' : {
				background   : '#888',
				borderRadius : '100px',
				'&:hover'    : {
					background : '#555'
				}
			}
		}
	});

const theme = createTheme({
	overrides : {
		MuiButton : {
			startIcon : {
				marginRight : '0'
			}
		}
	}
});

const MemoTable = ({
	classes,
	memos,
	onSelect,
	queryObj
}) =>
{
	const [ memoList, setMemoList ] = useState([]);

	const createMemoList = (query, list) =>
	{

		// search
		const memoFiltered = list.filter((memo) =>
		{
			if (query.name !== '' && memo.name.indexOf(query.name) === -1) return false;
			if (query.sms !== '' && memo.sms.indexOf(query.sms) === -1) return false;
			if (query.message !== '' && (
				memo.message.indexOf(query.message) === -1
					&& memo.title.indexOf(query.message) === -1
					&& (!memo.guestInput1
						|| !memo.guestInput1.value
						|| memo.guestInput1.value.indexOf(query.message) === -1)
					&& (!memo.guestInput2
						|| !memo.guestInput2.value
						|| memo.guestInput2.value.indexOf(query.message) === -1)
			))
			{
				return false;
			}

			if (query.date !== null && query.date !== '')
			{
				const queryDate = new Date(query.date);
				const memoDate = new Date(memo.timestamp);

				if (memoDate.getFullYear() !== queryDate.getFullYear()
				|| memoDate.getMonth() !== queryDate.getMonth()
				|| memoDate.getDate() !== queryDate.getDate())
				{
					return false;
				}
			}

			return true;
		});

		// marge
		const margedList = [];

		memoFiltered.forEach((item) =>
		{
			const presentMemo = margedList.find((present) =>
			{
				if (present.name === item.name
					&& (
						(present.guestInput1?.value === item.guestInput1?.value
						&& present.guestInput1?.key === item.guestInput1?.key)
						|| (present.guestInput2?.value === item.guestInput2?.value
						&& present.guestInput2?.key === item.guestInput2?.key)
					))
				{
					return true;
				}

				return false;
			});

			if (presentMemo)
			{
				// 追加変更
				presentMemo.status = item.status;
				presentMemo.timestamp = item.timestamp;
				presentMemo.title = item.title;
				presentMemo.details.push({

					user        : item.user,
					timestamp   : item.timestamp,
					title       : item.title,
					message     : item.message,
					comment     : item.comment,
					duration    : item.duration,
					email       : item.email,
					sms         : item.sms,
					guestInput1 : item.guestInput1,
					guestInput2 : item.guestInput2
				});
			}
			else
			{
				// 新規登録
				margedList.push(
					{
						id          : margedList.length + 1,
						name        : item.name,
						guestInput1 : item.guestInput1,
						guestInput2 : item.guestInput2,
						status      : item.status,
						title       : item.title,
						timestamp   : item.timestamp,
						details     : [
							{
								user        : item.user,
								timestamp   : item.timestamp,
								title       : item.title,
								message     : item.message,
								comment     : item.comment,
								duration    : item.duration,
								email       : item.email,
								sms         : item.sms,
								guestInput1 : item.guestInput1,
								guestInput2 : item.guestInput2
							}
						]
					}
				);
			}
		});

		// 最終通話日時でソート

		return margedList;
	};

	useEffect(() =>
	{
		if (memos && memos.length > 0)
		{
			setMemoList(createMemoList(queryObj, memos));
		}
	}, [ memos, queryObj ]);

	const getDateString = (timestamp) =>
	{
		const date = timestamp ? new Date(timestamp) : new Date();
		const month = (`0${date.getMonth() + 1}`).slice(-2);
		const day = (`0${date.getDate()}`).slice(-2);
		const hour = (`0${date.getHours()}`).slice(-2);
		const min = (`0${date.getMinutes()}`).slice(-2);

		return `${date.getFullYear()}/${month}/${day} ${hour}:${min}`;
	};

	return (
		<MuiThemeProvider theme={theme}>
			<Box className={classes.root}>
				<Box className={classes.tableTitle}>
					<SearchIcon className={classes.tableIcon} />
					<Typography>検索結果　{memoList.length} 件</Typography>
				</Box>
				<Box className={classes.table}>
					<Box className={classes.tableBg}>
						<Box className={classes.columnNo} />
						<Box className={`${classes.tableBgLine} ${classes.columnDate}`} />
						<Box className={`${classes.tableBgLine} ${classes.columnName}`} />
						<Box className={`${classes.tableBgLine} ${classes.columnNumber}`} />
						<Box className={`${classes.tableBgLine} ${classes.columnTitle}`} />
						<Box className={classes.columnAction} />
					</Box>
					<Box className={classes.scrollBar}>
						<ul>
							<Box className={classes.tableHeader}>
								<Box className={`${classes.tableHeaderText} ${classes.columnNo}`} />
								<Box className={`${classes.tableHeaderText} ${classes.columnDate}`}>
									最終通話日
								</Box>
								<Box className={`${classes.tableHeaderText} ${classes.columnName}`}>
									名　前
								</Box>
								<Box className={`${classes.tableHeaderText} ${classes.columnNumber}`}>
									件　数
								</Box>
								<Box className={`${classes.tableHeaderText} ${classes.columnTitle}`}>
									タイトル
								</Box>
								<Box className={`${classes.tableHeaderText} ${classes.columnAction}`} />
							</Box>
							{memoList.map((item, index) => (
								(<li className={classes.tableData} key={item.id}>
									<Box className={`${classes.columnNo}`}>
										<Box className={classes.columnNoData}>{index + 1}</Box>
									</Box>
									<Box position='absolute' width='100%' height='100%'>
										<Box className={`${classes.tableDataValues}`}>
											<Box
												className={`${classes.tableDataValue} ${classes.columnDate} ${classes.rowContentBg} ${classes.rowBorderStart}`}
											>
												<Box className={`${classes.tableDataValue} ${classes.itemCenter}`} flexDirection='column'>
													{item.status === MEMO_TODO_OPEN && <Box />}
													{getDateString(item.timestamp)}
													{(item.status === MEMO_TODO_CLOSE
													&& item.status === MEMO_CONFIRM) &&
														<Button
															className={classes.actionDate}
															startIcon={<PlayArrowIcon />}
														>
															対応済み
														</Button>
													}
												</Box>
											</Box>
											<Box className={`${classes.columnName} ${classes.rowContentBg}`}>
												<Box className={`${classes.tableDataValue} ${classes.itemCenter}`}>
													{item.name}
												</Box>
											</Box>
											<Box className={`${classes.columnNumber} ${classes.rowContentBg}`}>
												<Box className={`${classes.tableDataValue} ${classes.itemCenter}`}>
													{item.details.length} 件
												</Box>
											</Box>
											<Box className={`${classes.columnTitle} ${classes.rowContentBg}`}>
												<Box className={`${classes.tableDataValue} ${classes.itemLeft}`}>
													{item.title}
												</Box>
											</Box>
											<Box
												className={`${classes.columnAction} ${classes.rowContentBg} ${classes.rowBorderEnd}`}
											>
												<Box className={`${classes.tableDataValue} ${classes.itemCenter}`}>
													<Button
														className={classes.actionBtn}
														startIcon={<PlayArrowIcon />}
														onClick={() => onSelect(item)}
													>
														詳細
													</Button>
												</Box>
											</Box>
										</Box>
									</Box>
								</li>)
							))}
						</ul>
					</Box>
				</Box>
			</Box>
		</MuiThemeProvider>
	);
};

MemoTable.propTypes =
{
	classes  : PropTypes.object.isRequired,
	memos    : PropTypes.array.isRequired,
	onSelect : PropTypes.func.isRequired,
	queryObj : PropTypes.object
};

const mapStateToProps = (state) =>
{
	return {
		memos : state.room.memos
	};
};

const mapDispatchToProps = () =>
{
	return {
	};
};

export default withRoomContext(connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.room.memos === next.room.memos
			);
		}
	}
)(withStyles(styles)(MemoTable)));